<div *ngIf="_show" id="backdrop" class="ui-overlay ui-overlay-mask">
  <div class="process-text-container">
    <span class="process-text">{{_message | translate }}</span>
    <span class="process-subtext" [innerHTML]="_submessage | safe:'html'"></span>
  </div>
</div>
